module.exports = __webpack_public_path__ + "media/images/beauty/cover-mobile@3x-46ddaf04e4860c616ca0bda3208ec3bb.jpg";